import { APP_BACKGROUND_COLOR, BORDER_COLOR, TEXT_COLOR } from "../../theme";

export const styles = {
    mainContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90vw",
        backgroundColor: APP_BACKGROUND_COLOR,
        border: "2px solid #000",
        boxShadow: 24,
        padding: 4,
    } as const,
    tableOuterContainer: {
        overflow: "scroll",
        scrollbarWidth: "none",
        border: `1px solid ${BORDER_COLOR}`,
        marginTop: "10px",
        borderRadius: "var(--radius-2xl, 16px)",
        width: "100%",
        maxHeight: "300px",
        overflowY: "auto",
    } as const,
    tableMainContainer: {
        display: "flex",
        padding: "10px",
    } as const,
    countryContainer: {
        color: TEXT_COLOR,
        width: "16vw",
        minWidth: "200px",
    } as const,
    ipContainer: {
        color: TEXT_COLOR,
        width: "25vw",
        minWidth: "270px",
    } as const,
    infoCircle: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '17px',
        height: '17px',
        backgroundColor: 'grey',
        color: 'white',
        borderRadius: '50%',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        marginLeft: "5px"
    } as const,
}